import { Injectable, inject } from '@angular/core';

import { CasinoCoreGamelaunchService, CasinoLobbyService, CasinoManager, GameLaunch, GameManagerService } from '@casinocore/platform/core';
import { OnAppInit } from '@frontend/vanilla/core';
import { SearchAppQueryEventIdentifier } from '@globalsearch/productstub';
import { rxEffects } from '@rx-angular/state/effects';

import { McPageClientConfig } from '../../client-config';
import { GLobalSearchService } from '../../globalsearch/globalsearchservice';
import { GlobalSearchClientLoader } from '../../shared/services/global-search-client-loader.service';

interface GameLink {
    searchParams: { get: (arg0: string) => string };
}

@Injectable({ providedIn: 'root' })
export class GlobalSearchBootstrapService implements OnAppInit {
    private readonly casinoManager = inject(CasinoManager);
    private readonly mcPage = inject(McPageClientConfig);
    private readonly gameLaunchService = inject(CasinoCoreGamelaunchService);
    private readonly casinoLobbyService = inject(CasinoLobbyService);
    private readonly globalSearchClientLoader = inject(GlobalSearchClientLoader);
    private readonly globalSearchService = inject(GLobalSearchService);
    private readonly gameManagerService = inject(GameManagerService);

    previousUrl = this.mcPage.prefix;
    private readonly isAppEnabledQuery = 'isappenabled';
    private readonly queryToken = 'global-jackpot-query-isappenabled';
    private readonly rxEffects = rxEffects();

    onAppInit() {
        //Used for GlobalSearch
        this.registerEventHandlers();
        this.raiseIsAppEnabledQuery();

        //This is for performance and boostrap global search
        this.boostrapGlobalSearchOnLobbyLoad();

        //Initialise globalSearch
        //Why are there few event listeners added to globalService and here in this file?
        this.globalSearchService.init();
    }

    private raiseIsAppEnabledQuery() {
        dispatchEvent(
            new CustomEvent(SearchAppQueryEventIdentifier, {
                detail: {
                    query: this.isAppEnabledQuery,
                    queryToken: this.queryToken,
                },
            }),
        );
        dispatchEvent(new CustomEvent('gs:search:service:context:fetch'));
    }

    private registerEventHandlers() {
        addEventListener('gs:globalsearch:casinogamelaunch', this.launchGameGlobalSearch);
    }

    private readonly launchGameGlobalSearch = (customevent: CustomEventInit) => {
        if (customevent?.detail?.gameParams) {
            const gameLink = customevent.detail.gameParams;
            this.globalSearchGameLaunch(gameLink);
        }
    };

    private globalSearchGameLaunch(gameLink: GameLink) {
        const gameId = gameLink.searchParams.get('gameid');
        const launchLobbyType = gameLink.searchParams.get('launchLobbyType');
        const isTouch = this.casinoManager.isTouch();
        const gameInfo = this.gameManagerService.getGameInfo(gameId);
        let provider = gameInfo?.provider;
        const lobbyType = this.casinoManager.getCurrentLobby();
        const gameObj = {
            gameId,
            provider,
            lobbyType: launchLobbyType ? launchLobbyType : lobbyType,
        };
        const gameHomeUrl = gameLink.searchParams.get('returnUrl');
        const gameModel = new GameLaunch();
        gameModel.game = gameObj;
        gameModel.trackingproduct = gameLink.searchParams.get('specialproduct');
        gameModel.returnUrl = gameHomeUrl;
        gameModel.isTouch = isTouch;
        gameModel.categoryType = gameLink.searchParams.get('specialproduct');
        gameModel.clickTimeStamp = gameLink.searchParams.get('clickTimeStamp');
        gameModel.recommendationType = gameLink.searchParams.get('recommendationType');
        if (!gameModel.clickTimeStamp) {
            gameModel.clickTimeStamp = this.gameLaunchService.currentTimeStamp();
        }
        let Globalsearchsection: string = gameLink.searchParams.get('tracking:containerName')?.split('+').join(' ') || '';
        const Globalsearchgameposition = parseInt(gameLink.searchParams.get('tracking:position'));
        gameModel.Globalsearchsection = Globalsearchsection;
        gameModel.Globalsearchgameposition = Globalsearchgameposition;
        gameModel.gameLaunchedFrom = gameModel.trackingproduct;
        gameModel.gamePosition = Number(gameLink.searchParams.get('tracking:position'));
        this.gameLaunchService.launchGame(gameModel);
    }

    private boostrapGlobalSearchOnLobbyLoad(): void {
        this.rxEffects.register(this.casinoLobbyService.lobbyLoadedObservable, (result) => {
            if (result) {
                this.globalSearchClientLoader.startLoading();
            }
        });
    }
}
